<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { Gauge, ReceiptText } from 'lucide-vue-next';
import EnBanner from 'Components/alert/EnBanner/EnBanner.vue';
import EnTooltip from 'Components/base/EnTooltip/EnTooltip.vue';
import { dateFormat } from 'Js/utils/dateFormat';

const props = defineProps({
  message: Object,
  isPanel: Boolean,
  canBeClosed: {
    type: Boolean,
    default: true
  },
  messageClose: Function
});
const {t} = useI18n();
const date = ref(dateFormat(props.message.localDate));

const variant = computed(() => {
  switch (props.message.type) {
    case 'Warning':
      return 'warning';
    case 'Error':
      return 'error';
    default:
      return 'info';
  }
});

// Undefined lets the banner fall back to its own icon for the variant.
const icon = computed(() => {
  switch (props.message.area) {
    case 'EnVoice':
      return ReceiptText;
    case 'EnCount':
      return Gauge;
    default:
      return undefined;
  }
});

function handleClose() {
  if(!props.isPanel) {
    props.messageClose();
  }
}
</script>

<template>
  <en-banner
      class="notification-message"
      :variant="variant"
      :icon="icon"
      :closable="canBeClosed"
      @close="handleClose"
  >
    <div class="font-medium">{{ message.title }}</div>
    <div>{{ message.message }}</div>
    <div class="flex flex-wrap flex-auto mt-2 justify-end" v-if="message.url && message.triggerDownload"><a
        :href="message.url">Link</a></div>
    <div v-else-if="message.url && !message.triggerDownload" class="flex flex-wrap flex-auto mt-2 justify-end">
      <en-tooltip :text="t('notifications.obsoleteUrl')" position="bottom">
        <a class="cursor-default">Link</a>
      </en-tooltip>
    </div>
    <div class="float-end" v-if="!isPanel">{{ date }}</div>
  </en-banner>
</template>
